export const parsePassport = (value: string | undefined) => {
  if (!value) return value;

  return value.replace(/[^а-яёa-z№"'\-\\/.,():\d` ]/gi, '');
};
